namespace advisorop.components.advisor {
    
    export class AccountGroupingController{
        $router;

        //dropdowns
        households: Array<domains.IHousehold>;
        groupTypes: Array<domains.ILOV>;
        accountGroups: Array<domains.IAccountGroup>;
        investors: Array<domains.IInvestor>;

        //selected drop downs items
        selHousehold: domains.IHousehold;
        selGroupType: domains.ILOV;
        selGroup: domains.IAccountGroup;
        selInvestor: domains.IInvestor;

        //additional controls
        newGroupName: string;
        selectedGroupId: number;
        householdId: number;

        //accounts
        availableAccounts: Array<domains.IAccount> = [];

        dbAccountInsideOfGroup: Array<domains.IAccountGroupAccount>;
        accountsInsideOfGroup: Array<domains.IAccountGroupAccount>;
        accountsOfInsideOfGroup: Array<domains.IAccount>;

        relatedAdvisoryFirmId: number;

        includeClosedAccounts: boolean = false;

        selectedHousehold: domains.IHousehold = null;

        static $inject = ["$scope"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private $scope: ng.IScope) {            
            
        }

        loadHouseholds(): void {
            this.advisorService.getHouseholds(false,false).then((data) => {
                this.households = data.data;
            }).catch((err) => {
                toastr.error("Error "+err.status + " " + err.data);
            });
        };

        loadAvailableAccounts() {
            this.availableAccounts = [];

            if (!this.selHousehold || !this.selHousehold.id) {
                return;
            }

            //console.log('Loading available accounts:', this.selHousehold.id);
            this.advisorService.getAvailableAccountsForGroupping(this.selHousehold.id, this.includeClosedAccounts, this.selectedGroupId)
                .then((data) => {
                    if (this.selGroupType && this.selGroupType.value == domains.AccountGroupType.RTG) {
                        this.availableAccounts = data.data.filter(v => { return v.advisoryFirmMgtRole == domains.AdvisoryFirmMgtRole.MANAGED; });
                    }
                    else if (this.selGroupType && this.selGroupType.value == domains.AccountGroupType.HOUSEHOLD) {
                        this.availableAccounts = data.data.filter(v => { return v.advisoryFirmMgtRole == domains.AdvisoryFirmMgtRole.UNMANAGED; });
                    }
                    else {
                        this.availableAccounts = data.data;
                    }
                    
                }).catch((data) => {
                    //console.log(data);
                });
        };

        loadAccountGroups(): void {

            this.accountGroups = [];

            if (!this.selGroupType) {
                return;
            }


            var rez = this.advisorService.getAccountGroupsByGroupType(this.selGroupType.value, this.relatedAdvisoryFirmId);

            rez.then((data) => {

                this.accountGroups = data.data.filter((v) => { return v.householdId == this.selHousehold.id; });

                this.selectDefaultHouseholdGroup();

            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };
        
        loadAccountsOfAccountGroup(): void {

            this.accountsInsideOfGroup = [];
            this.accountsOfInsideOfGroup = [];
            
            if (!this.selGroup) {
                return;
            }
            //console.log('Loading accounts of a group:', this.selGroup.id, this.selGroup.accountGroupDescription);
            this.advisorService.getAccountGroup(this.selGroup.id)
                .then((data) => {
                    this.dbAccountInsideOfGroup = data.data.accounts.filter(p => p.account.custodianAccountId == null);

                    /*if (this.includeClosedAccounts)*/
                    angular.copy(data.data.accounts.filter(p => p.account.custodianAccountId == null), this.accountsInsideOfGroup);
                    this.accountsOfInsideOfGroup = this.accountsInsideOfGroup.map(a => a.account);
                    /*else
                        angular.copy(data.data.accounts.filter(p => p.account.status == domains.AccountStatus.OPEN), this.accountsInsideOfGroup);*/

                }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };

        includeClosedAccountsChanged(): void {
            this.loadAvailableAccounts();

            if (this.includeClosedAccounts) {
                angular.copy(this.dbAccountInsideOfGroup, this.accountsInsideOfGroup);
                this.accountsOfInsideOfGroup = this.accountsInsideOfGroup.map(a => a.account);
            }                
            else {
                if (this.dbAccountInsideOfGroup != undefined)
                    angular.copy(this.dbAccountInsideOfGroup.filter(p => p.account.status == domains.AccountStatus.OPEN), this.accountsInsideOfGroup);
                    this.accountsOfInsideOfGroup = this.accountsInsideOfGroup.map(a => a.account);
            }
        }

        selectDefaultHouseholdGroup() {
            if (this.selHousehold &&
                this.selGroupType &&
                this.accountGroups &&
                this.selGroupType.value == 3 &&
                this.accountGroups.length > 0) {

                this.selGroup = this.accountGroups[this.accountGroups.length - 1];
                //console.log("Household group is:" + this.selGroup.groupName);

                this.loadAccountsOfAccountGroup();
            }
        };

        moveAccounts() {
            //console.log("Move button was clicked");
            this.$scope.$broadcast("moveAccounts");
        }
        //events
        onHouseholdChanged = (): void => {
            //console.log('HH changed:', this.selHousehold.id, this.selHousehold.name);

            this.selGroup = null;

            this.selInvestor = null;
            
            this.investors = this.selHousehold.investors;

            this.relatedAdvisoryFirmId = this.selHousehold.advisoryFirmId;

            this.loadAccountGroups();
            
            this.loadAvailableAccounts();

            this.loadAccountsOfAccountGroup();
            //console.log('END: HH changed:', this.selHousehold.id, this.selHousehold.name);
        };

        onAccountGroupTypeChanged() {
            //console.log('START:Account group type changed:', this.selHousehold.id, this.selHousehold.name);
            this.selGroup = null;
            this.selectedGroupId = null;

            this.loadAccountGroups();
            
            this.loadAvailableAccounts();

            this.loadAccountsOfAccountGroup();
            //console.log('END: Account group type changed :', this.selHousehold.id, this.selHousehold.name);
        };

        onAccountGroupChanged() {
            this.selectedGroupId = this.selGroup.id;

            //console.log("U grupingu");
            //console.log(this.selectedGroupId);
            this.loadAccountsOfAccountGroup();
            this.loadAvailableAccounts();
        };

        onInvestorChanged() {
            //this.loadAvailableAccounts();
        };

        updatedGroupName(name: domains.IAccountGroup): void {
            //console.log("Updated name in accsount grouping component");
            //console.log(name.groupName);

           // this.selGroup = name;
            this.loadAccountGroups();
            this.selGroup = this.accountGroups.filter((v) => { return v.id == name.id; })[0];
        }

        onCreateNewGroup(): void {
            if (!this.newGroupName) {
                toastr.warning("Please enter group name");
                return;
            }

            let accountGroup: domains.IAccountGroup = {
                accountGroupDescription: this.newGroupName,
                accountGroupType: this.selGroupType.value,
                groupName: this.newGroupName,
                householdId: this.selHousehold.id
            };

            this.advisorService.createAccountGroup(accountGroup)
                .then((data) => {
                    this.accountGroups.push(data.data);
                    this.selGroup = data.data;
                    toastr.success("New account group successfully created.");
                    this.newGroupName = "";

                   
                })
                .catch((data) => {
                    toastr.error("ERROR " + data.status + " " + data.data);
                });
        };

        //event handlers from components
        rtqSelected(rtq: domains.IRTQ): void {
        };

        rtqCreated(rtq: domains.IRTQ): void {            
            if (rtq) {
                this.advisorService.getAccountGroup(rtq.accountGroupId).then((data) => {
                    var len = this.accountGroups.push(data.data);
                    this.selGroup = this.accountGroups[len - 1];
                    this.onAccountGroupChanged();
                }).catch((data) => {
                    //console.log(data.status + ":" + data.data);
                });
            }
        };

        onFinishedAccountGruping(): void {

            if (this.accountsInsideOfGroup.length <= 0) {
                toastr.warning("Please do some grouping of accounts.");
                return null;
            }

            if (this.householdId > 0) {
                this.$router.navigate(['AdvisorHouseholdDashboard', { householdId: this.householdId }]);
            }
        }

        addAccountToGroup(account: domains.IAccount) {

            //account group must be selected
            if (!this.selGroup || !this.selGroupType) {
                toastr.warning("Please select Account Group Type and Account Group.");
                return;
            }


            var accs = this.accountsInsideOfGroup.filter((v) => {
                return v.accountGroupId == this.selGroup.id &&
                    v.accountId == account.id /* &&
                    v.investorId == this.selInvestor.id*/;
            });
            if (accs.length > 0) {                
                toastr.info("Account is already in the group");
                return;
            }

            let accountGroupAccount: domains.IAccountGroupAccount = {
                account: account,
                accountGroup: this.selGroup,
                accountGroupId: this.selGroup.id,
                accountId: account.id,
                id: 0,
                //investor: this.selInvestor,
                investorId: 0 //this.selInvestor.id
            };

            this.accountsOfInsideOfGroup.push(account);
            this.accountsInsideOfGroup.push(accountGroupAccount);
            let indexOfAvailableAccount = this.availableAccounts.indexOf(account);
            this.availableAccounts.splice(indexOfAvailableAccount, 1);

            this.advisorService.addAccountToAccountGroup(accountGroupAccount)
                .then((data) => {
                    //this.accountsInsideOfGroup.push(data.data);
                    //this.loadAccountsOfAccountGroup();
                    //this.loadAvailableAccounts();
                }).catch((data) => {
                    toastr.warning("Error " + data.status + ": " + data.data);
                });
        };


        removeAccountFromGroup(account: domains.IAccount) {
            
            //console.log("removing account from account group...");
            //console.log(account);
            let accountGroupAccount = this.accountsInsideOfGroup.filter(a => a.account == account)[0];
            let indexOfAccountGroupAccount = this.accountsInsideOfGroup.indexOf(accountGroupAccount);
            let indexOfAccount = this.accountsOfInsideOfGroup.indexOf(account);
            if (indexOfAccountGroupAccount == -1) {
                return;
            }

            this.accountsOfInsideOfGroup.splice(indexOfAccount, 1);
            this.accountsInsideOfGroup.splice(indexOfAccountGroupAccount, 1);
            this.availableAccounts.push(account);

            this.advisorService.removeAccountToAccountGroup(accountGroupAccount).then((data) => {
                //this.loadAccountsOfAccountGroup();
                //this.loadAvailableAccounts();
            });            
        };

        removeAdvisorDefinedGroup(groupId: number) {
            //console.log("### AccountGroupgId for Delete:", groupId);

            this.advisorService.removeAdvisorDefinedGroup(groupId).then((data) => {
                this.onAccountGroupTypeChanged();
            });            
        }
        
        loadHouseholdById(householdId: number): void {
            this.advisorService.getHousehold(householdId)
                .then(data => {
                    this.selHousehold = data.data;

                    this.investors = this.selHousehold.investors;

                    if (this.groupTypes != undefined) {
                        this.selGroupType = this.groupTypes.filter(g => { return g.value === 2 })[0];
                    }

                    this.loadAccountGroups();

                    this.loadAvailableAccounts();

                    this.loadAccountsOfAccountGroup();

                })
                .catch(err => { toastr.error("Unable to fetch household."); })
        }

        search(searchTerm: string): ng.IPromise<{}> {
            //console.log("search");
            return this.advisorService.searchHouseholds(searchTerm).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            this.selHousehold = item;
            this.onHouseholdChanged();
            this.resetSearch();
        };

        resetSearch(): void {
            this.selectedHousehold = null;
            //this.selectedHousehold = null;
            //this.onHouseholdChanged();
        };

        $onInit(): void {
            // Do not allow RTGs to be edited via this screen
            this.generalService.getLOVs().then((data) => {
                this.groupTypes = data.filter((v) => { return v.lovType === domains.LovType.ACCOUNT_GROUP_TYPE && v.value !== domains.AccountGroupType.RTG; });
            });

            this.loadHouseholds();
        }


        $routerOnActivate(next, previous) {     
            this.householdId = <number>next.params.householdId;
            if (this.householdId > 0) {
                this.loadHouseholdById(this.householdId);
            }
        }        

    }



    class AccountGrouping implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;  
        $canActivate;      

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["advisorService", "generalService", "$scope", AccountGroupingController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/account-grouping.html';   
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable account grouping");
                    return false;
                }
                return true;
            }];         
        }
    }
    angular.module(Constants.APP).component("accountGrouping", new AccountGrouping());
    
}